import axios from '@/js/helper/axios-helper.js'
import { get, isUndefined } from 'lodash-es'
import { mapGetters } from 'vuex'

import { types as STORE_MODULES } from '@/js/plugins/store/store-modules.js'
import AIMEOS_META_CONSTANTS from '@/js/helper/aimeos-meta-constants.js'
import AIMEOS_GETTER_TYPES from '@/js/plugins/store/modules/aimeos/getter-types'

import { generateBasketAttributesFromBasketinfo } from '@/js/helper/product-data-helper.js'

export default {
  data() {
    return {
      requestedBasketAttributes: {},
      productDataPending: false,
    }
  },
  computed: {
    ...mapGetters(STORE_MODULES.AIMEOS, {
      getUrl: AIMEOS_GETTER_TYPES.GET_OPTIONS_PROMISE_URL,
    }),
  },
  methods: {
    async requestProductData(fetchAvailability = false, togglePending = true) {
      if (togglePending) {
        this.productDataPending = true
      }
      await this.getBasketInfo([this.productId], fetchAvailability)
      if (togglePending) {
        this.productDataPending = false
      }
    },
    async getBasketInfo(ids, fetchAvailibility = false) {
      const url = await this.getUrl(AIMEOS_META_CONSTANTS.PATHS.PRODUCT).catch(e => console.log(e))
      if (isUndefined(url)) {
        this.requestedBasketAttributes = {}
      }
      const include = fetchAvailibility
        ? 'attribute,product,price,text,availability'
        : 'attribute,price,product,text'
      const response = await axios
        .get(`${url}&ai%5Binclude%5D=${include}&ai%5Bbasketinfo%5D=${ids.join(',')}`)
        .catch(error => {
          console.log(error.message)
          // return Promise.reject(new Error(error.message))
          return []
        })

      this.requestedBasketAttributes = generateBasketAttributesFromBasketinfo({
        apiData: get(response, 'data', []),
      })
    },
    getBasketProductEntry(additionalAttributes, productId, relatedId) {
      const result = {
        attributes: {
          'product.id': productId || this.productId,
          ...additionalAttributes,
        },
      }

      if (!isUndefined(relatedId)) {
        result['relatedId'] = relatedId
      }

      return result
    },
  },
}
